import { useExitAction } from './simpleActions';
import useDeleteFileAction from './useDeleteFileAction';
import useFinishLaterAction from './useFinishLaterAction';
import useExitWithoutSavingAction from './useExitWithoutSavingAction';
import useLoadNextAction from './useLoadNextAction';
import useOnCloseModal from './useOnCloseModal';
import useStartStepAction from './useStartStepAction';
import useSubmitAssessmentAction from './useSubmitAssessmentAction';
import useSubmitResponseAction from './useSubmitResponseAction';
import useConfirmAction from './useConfirmAction';
// eslint-disable-next-line import/no-cycle
import useCloseModalAction from './useCloseModalAction';

export {
  useCloseModalAction,
  useConfirmAction,
  useDeleteFileAction,
  useExitAction,
  useExitWithoutSavingAction,
  useFinishLaterAction,
  useLoadNextAction,
  useOnCloseModal,
  useStartStepAction,
  useSubmitAssessmentAction,
  useSubmitResponseAction,
};

export default {
  useCloseModalAction,
  useConfirmAction,
  useDeleteFileAction,
  useExitAction,
  useExitWithoutSavingAction,
  useFinishLaterAction,
  useLoadNextAction,
  useOnCloseModal,
  useStartStepAction,
  useSubmitAssessmentAction,
  useSubmitResponseAction,
};
